import {
  DataTable,
  PageHeader,
  Breadcrumb,
  nameImageFormatter,
} from "components";
import { dateWithString } from "helpers";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import adminRouteMap from "routeControl/adminRouteMap";
import { ManageCouponService } from "services";
import { checkValidData, dateFormatter, logger } from "utils";

function UsedCoupon() {
  const [loading, setLoading] = useState(false);

  const { t } = useTranslation();
  const [CouponData, setCouponData] = useState([]);
  const { id } = useParams();

  const tableReset = () => {
    setLoading(true);
    setCouponData([]);
  };

  const getCouponConsumptionList = async () => {
    setLoading(true);
    try {
      const { data, success } = await ManageCouponService.getConsumptionList(
        id
      );
      if (success && data) {
        setCouponData(data);
      }
    } catch (err) {
      logger(err);
    }
    setLoading(false);
  };
  useEffect(() => {
    getCouponConsumptionList();
  }, []);

  const CouponColumns = [
    {
      dataField: "name",
      text: "Coupon Used By",
      formatter: (cell, row) => {
        let name = ` ${row?.user?.firstName} ${row?.user?.lastName}`;
        return nameImageFormatter(name, row?.user?.profileImageUrl);
      },
    },
    {
      dataField: "subscription",
      text: "Subscription Name",
      formatter: (cell, row) =>
        checkValidData(row?.userSubscription?.subscription?.name),
    },
    {
      dataField: "date",
      text: "Used Date",
      formatter: (cell, row) => dateFormatter(row?.createdAt, dateWithString),
    },
  ];
  const breadcrumb = [
    {
      path: adminRouteMap.DASHBOARD.path,
      name: t("text.common.dashboard"),
    },
    {
      path: adminRouteMap.MANAGE_COUPEN.path,
      name: "Manage Coupons",
    },
    {
      path: "#",
      name: "Coupon Consumption",
    },
  ];
  return (
    <>
      <div className="nk-block-head nk-block-head-sm">
        <div className="nk-block-between">
          <PageHeader heading="Manage Coupons">
            <Breadcrumb breadcrumb={breadcrumb} />
          </PageHeader>{" "}
        </div>
      </div>
      <DataTable
        hasLimit
        tableData={CouponData}
        tableColumns={CouponColumns}
        tableReset={tableReset}
        tableLoader={loading}
        pagination={false}
      />
    </>
  );
}

export default UsedCoupon;
